import { render, staticRenderFns } from "./ReceiptContainer.vue?vue&type=template&id=7471d44a"
import script from "./ReceiptContainer.vue?vue&type=script&lang=js"
export * from "./ReceiptContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports